import React, { useEffect, useState } from 'react';
import AOS from 'aos';
import { MdOutlineFeaturedPlayList } from "react-icons/md";
import { useTheme } from './ThemeContext';

const Features = () => {
    const { isDarkMode } = useTheme();
    const [showParagraph, setShowParagraph] = useState(false);

    const handleLiClick = () => {
        setShowParagraph(!showParagraph);
    };

    const [showParagraph1, setShowParagraph1] = useState(false);

    const handleLiClick1 = () => {
        setShowParagraph1(!showParagraph1);
    };

    const [showParagraph2, setShowParagraph2] = useState(false);

    const handleLiClick2 = () => {
        setShowParagraph2(!showParagraph2);
    };

    const [showParagraph3, setShowParagraph3] = useState(false);

    const handleLiClick3 = () => {
        setShowParagraph3(!showParagraph3);
    };

    const [showParagraph4, setShowParagraph4] = useState(false);

    const handleLiClick4 = () => {
        setShowParagraph4(!showParagraph4);
    };

    const [showParagraph5, setShowParagraph5] = useState(false);

    const handleLiClick5 = () => {
        setShowParagraph5(!showParagraph5);
    };

    const [showParagraph6, setShowParagraph6] = useState(false);

    const handleLiClick6 = () => {
        setShowParagraph6(!showParagraph6);
    };
    
    useEffect(() => {
        AOS.init({
            duration: 1000
        });
    })

    return (
        <div className={`px-10 py-10 text-zinc-600  md:px-20 lg:px-24 dark:text-zinc-300 ${isDarkMode ? 'dark' : ''}`} data-aos="fade-up" id='features' >
            <div className='flex items-center gap-3 '>

                <h1 className='mt-20  text-3xl font-extrabold md:text-4xl'>Our Features</h1>
                <div>
                    <MdOutlineFeaturedPlayList className='h-8 mt-20 w-10' />
                </div>
            </div>
            <div className='mt-6 md:text-2xl '>
                <li
                    className='list-item hover:underline text-lg font-bold hover:text-[#3FE0A5]  cursor-pointer md:text-3xl '
                    onClick={handleLiClick}
                >
                    Most Recent Past Paper Access:
                </li>
                {showParagraph && (
                    <p data-aos="fade-left" className='text-zinc-600 dark:text-zinc-400 pl-14 md:pl-14 text-justify'>
                        Gain access to the latest past papers from various entry tests,
                        providing valuable insight into the exam format and types of
                        questions asked.
                    </p>
                )}
                <li onClick={handleLiClick1} className='list-item hover:underline font-bold text-lg mt-8 cursor-pointer hover:text-[#3FE0A5] md:text-3xl  '>
                    Full Guide with Tutor Expert MCQs Practice:
                </li>
                {showParagraph1 && (
                    <p data-aos="fade-left" className='text-zinc-600 pl-14 md:pl-14 dark:text-zinc-400 text-justify '>
                        Receive comprehensive study guides prepared by expert tutors,
                        along with focused Multiple Choice Questions (MCQs) practice sessions tailored to each subject.

                    </p>
                )}
                <li onClick={handleLiClick2} className='list-item hover:underline font-bold text-lg mt-8 cursor-pointer hover:text-[#3FE0A5] md:text-3xl  '>
                    Motivational Guidance:
                </li>
                {showParagraph2 && (
                    <p data-aos="fade-left" className='text-zinc-600 pl-14 dark:text-zinc-400 md:pl-14 text-justify'>
                        Access motivational content and guidance to keep students inspired and focused throughout
                        their preparation journey, helping them stay motivated and confident.
                    </p>
                )}
                <li onClick={handleLiClick3} className='list-item hover:underline  font-bold text-lg mt-8 cursor-pointer hover:text-[#3FE0A5] md:text-3xl '>
                    Roadmap to Full Test to Interview:
                </li>
                {showParagraph3 && (
                    <p data-aos="fade-left" className='text-zinc-600 pl-14 dark:text-zinc-400 md:pl-14 text-justify'>
                        Get a step-by-step roadmap outlining the preparation journey from the initial test to the
                        final interview stage, ensuring comprehensive coverage and readiness.


                    </p>
                )}
                <li onClick={handleLiClick4} className='list-item hover:underline font-bold text-lg mt-8 cursor-pointer hover:text-[#3FE0A5] md:text-3xl '>
                    Each Test Position Certifications:
                </li>
                {showParagraph4 && (
                    <p data-aos="fade-left"
                        className='text-zinc-600 pl-14 md:pl-14 text-justify dark:text-zinc-400'>
                        Earn certifications for each test position completed successfully, validating the student's proficiency and readiness for the respective entry test.

                    </p>
                )}
                <li onClick={handleLiClick5} className='list-item hover:underline font-bold text-lg cursor-pointer mt-8 hover:text-[#3FE0A5] md:text-3xl  '>
                   Daily, Weekly, and Grand Mock Tests:
                </li>
                {showParagraph5 && (
                    <p data-aos="fade-left"
                        className='text-zinc-600 pl-14 md:pl-14 text-justify dark:text-zinc-400'>
                        Participate in regular mock tests designed to simulate the actual exam environment,
                        with options for weekly, monthly, and mega mock tests to assess progress and readiness effectively

                    </p>
                )}

                <li onClick={handleLiClick6} className='list-item hover:underline font-bold text-lg cursor-pointer mt-8 hover:text-[#3FE0A5] md:text-3xl  '>
                   Youtube Lectures
                </li>
                {showParagraph6 && (
                    <p data-aos="fade-left"
                        className='text-zinc-600 pl-14 md:pl-14 text-justify dark:text-zinc-400'>
                       We will provide most important youtube video lectures for your better understanding as video solutions for clearing your concepts
                    </p>
                )}
                
            </div>
        </div>
    );
};

export default Features;
